import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteNames } from '../constans/routes';
import { useAuth } from '../hooks/useAuth';

interface IGuardedElement {
  component: ReactElement;
  requiredRoles: string[];
  redirectTo?: string | RouteNames;
}

const GuardedElement: React.FC<IGuardedElement> = ({
  component,
  requiredRoles,
  redirectTo = RouteNames.SessionExpired,
}) => {
  const { tokenAndRoleValidation, userData } = useAuth();
  const redirectLink = userData?.access ? RouteNames.Page404 : redirectTo;
  const user = tokenAndRoleValidation(requiredRoles);
  const Element = user ? component : <Navigate to={redirectLink} replace />;
  return Element;
};

export default GuardedElement;
